/**
 * 最大图片文件大小限制，单位为MB
 * 项目中通用视频大小限制：4MB
 * 非通用限制可局部控制
 */
export const MAX_FILE_SIZE = 4;
/**
 * 最大视频文件大小限制，单位为MB
 * 项目中通用视频大小限制：50MB
 * 非通用限制可局部控制
 */
export const MAX_VIDEO_FILE_SIZE = 50;
/**
 * 最长视频时长限制，单位为s
 * 项目中通用视频长度限制：15s
 * 非通用限制可局部控制
 */
export const MAX_VIDEO_FILE_DURATION = 15;
/**
 * 导出方法区分不同系统
 */
export enum FileExportSystem {
  OS = "os",
  ERP = "erp",
}

/**
 * obs文件上传域名
 */
export const FileUploadDomain =
  "https://yishou-img.obs.cn-south-1.myhuaweicloud.com";

/**
 * cdn 文件上传域名
 */
export const FileUploadCdnDomain = "https://img4.yishouapp.com";
